import React from 'react';
import { useSafariAuthPersistence } from '../../hooks/useSafariAuthPersistence';
import { useCrossTabAuth } from '../../hooks/useCrossTabAuth';

const AuthPersistence: React.FC = () => {
  useSafariAuthPersistence();
  useCrossTabAuth();
  return null;
};

export default AuthPersistence;
